<template lang="pug">
.static-header-bar(@click="expanded = false")
  .backdrop(v-if="expanded")
  .layout.flex.inner-gap
    .toggler(@click.stop="expanded = !expanded")
      i.pf-icon.bx.bx-menu
    .logo
      landing-link(path="/" title="Pod")
        img(src="/img/logo.svg?pod" alt="Pod" width="190" height="40")

    .menu(:class="{ expanded }" @click.stop)
      landing-link.menu-item(path="/about" title="About Pod") About

      .menu-sub.hidden-md-and-up
        landing-link.menu-item(path="/services/brands" title="Pod for Brands") Pod for Brands
        landing-link.menu-item(path="/services/retailers" title="Pod for Retailers") Pod for Retailers

      el-dropdown.hidden-sm-and-down
        span.menu-item Services
          i.bx.bx-chevron-down
        el-dropdown-menu(slot="dropdown")
          el-dropdown-item
            landing-link(path="/services-brands" title="Pod for Brands") Pod for Brands
          el-dropdown-item
            landing-link(path="/services-retailers" title="Pod for Retailers") Pod for Retailers

      landing-link.menu-item(path="/pricing" title="Pricing") Pricing
      landing-link.menu-item(path="/products" title="Catalog" v-click="() => $amplitude.track('CLICK_CATALOG')") Catalog

      .menu-sub.hidden-md-and-up
        landing-link.menu-item(path="/media#bloomberg-2024" title="Bloomberg 2024") Bloomberg 2024
        landing-link.menu-item(path="/media" title="Press Releases") Press Releases
        landing-link.menu-item(path="/blog" title="Blog") Blog
        landing-link.menu-item(path="/podcasts" title="Podcasts") Podcasts

      el-dropdown.hidden-sm-and-down
        span.menu-item Media
          i.bx.bx-chevron-down
        el-dropdown-menu(slot="dropdown")
          el-dropdown-item
            landing-link(path="/media#bloomberg-2024" title="Bloomberg 2024") Bloomberg 2024
          el-dropdown-item
            landing-link(path="/media" title="Press Releases") Press Releases
          el-dropdown-item
            landing-link(path="/blog" title="Blog") Blog
          el-dropdown-item
            landing-link(path="/podcasts" title="Podcasts") Podcasts

    .user
      user-box
</template>

<script>
import UserBox from './UserBox'

export default {
  components: {
    UserBox
  },

  data () {
    return {
      expanded: false
    }
  },

  head () {
    return {
      bodyAttrs: {
        class: this.expanded ? 'pf-no-scroll' : ''
      }
    }
  },

  watch: {
    $route () {
      this.expanded = false
    }
  }
}
</script>

<style lang="scss" scoped>
.static-header-bar {
  background: rgba(white, .98);
  border-bottom: 1px solid #f1f1f1;
  position: sticky;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  // backdrop-filter: blur(20px);
  .backdrop {
    @include media(sm-down) {
      position: fixed;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      background: rgba(black, .1);
      z-index: -1;
    }
  }
  .layout {
    align-items: center;
    min-height: 50px;
    @include media(md) {
      min-height: 90px;
    }
    .toggler {
      display: block;
      margin-right: .75em;
      @include media(md) {
        display: none;
      }
    }
    .logo {
      flex: 140px 0;
      padding: 10px 0;
      @include media(md) {
        flex: 220px 0;
      }
      @include media(lg) {
        flex: 310px 0;
      }
      img {
        display: block;
        width: 140px;
        @include media(md) {
          width: 160px;
        }
      }
    }
    .menu {
      @include media(sm-down) {
        display: none;
        position: fixed;
        top: 0;
        left: 0;
        bottom: 0;
        width: 240px;
        background: white;
        z-index: -1;
        padding: 50px 1em 1em;
        &.expanded {
          display: block;
        }
        > a, div {
          display: block;
          padding: 1em 0;
          color: $--color-text-regular;
          border-bottom: 1px solid #eee;
        }
        a.nuxt-link-exact-active {
          color: $--color-primary;
          font-weight: $--font-weight-bold;
        }
      }
      @include media(md) {
        flex: 1;
        display: flex;
        align-items: center;
        justify-content: center;
        > a, div {
          padding: 35px 0;
          border-bottom: 2px solid transparent;
          color: $--color-text-regular;
          margin: 0 12px;
          @include media(lg) {
            margin: 0 16px;
          }
          &.nuxt-link-exact-active {
            border-bottom-color: $--color-primary;
          }
        }
        > div {
          padding: .75em 0;
        }
      }

      &-item {
        font-size: 16px;
        line-height: 120%;
        padding: 8px 0;
        display: flex;
        align-items: center;
        gap: 0px;
        cursor: pointer;
        transition: color .2s ease-in-out;
        &:hover {
          color: $--color-primary;
        }
        i {
          font-size: 20px;
          color: $--color-primary;
        }
      }
    }
    .user {
      text-align: right;
      flex: 0 410px;
      @include media(sm-down) {
        flex: 1;
      }
    }
  }
}
</style>
